import AbstractWidget from "@/models/PlatinumWidget/AbstractWidget";
import Slide from "@/models/PlatinumWidget/Gallery/Slide/Slide";
import PlatinumWidget from "@/models/PlatinumWidget/PlatinumWidget";
import orderBy from 'lodash/orderBy';

export default class Gallery extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/gallery';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetGalleries';

    static model_name = 'Gallery';

    static fields() {
		return {
            id: this.number(null).nullable(),
            display_type: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(PlatinumWidget, 'widgetable_id'),
            slides: this.hasMany(Slide, 'platinum_widget_gallery_id'),
        }
	}

    /**
     *
     * @constructor
     */
    Slides() {
        return orderBy(this.getRelated('slides'), 'rank');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return PlatinumWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
